import { render, staticRenderFns } from "./pay-successful.vue?vue&type=template&id=9b0aa324&"
import script from "./pay-successful.vue?vue&type=script&lang=js&"
export * from "./pay-successful.vue?vue&type=script&lang=js&"
import style0 from "./pay-successful.vue?vue&type=style&index=0&id=9b0aa324&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports